import React from 'react';
import { categoryLabels } from '../constants';

export function DuesConfigModal({ show, configForm, setConfigForm, onSave, onClose }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-lg w-full p-6 max-h-[90vh] overflow-y-auto">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">Configure Family Dues</h3>
        <form onSubmit={onSave} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Billing Cycle</label>
            <select
              value={configForm.billing_cycle}
              onChange={(e) => setConfigForm({...configForm, billing_cycle: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            >
              <option value="monthly">Monthly</option>
              <option value="quarterly">Quarterly</option>
              <option value="annually">Annually</option>
            </select>
          </div>
          
          <div>
            <label className="block text-gray-700 font-medium mb-2">Due Day of Period</label>
            <input
              type="number"
              min="1"
              max="28"
              value={configForm.due_day}
              onChange={(e) => setConfigForm({...configForm, due_day: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
            />
          </div>

          <div className="border-t pt-4">
            <h4 className="font-medium text-gray-700 mb-3">Dues Amounts by Category</h4>
            <div className="grid grid-cols-2 gap-4">
              {['adult', 'senior', 'youth', 'child'].map(cat => (
                <div key={cat}>
                  <label className="block text-gray-600 text-sm mb-1">{categoryLabels[cat]} ($)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={configForm[`${cat}_amount`]}
                    onChange={(e) => setConfigForm({...configForm, [`${cat}_amount`]: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="flex space-x-4 pt-4">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">
              Save Configuration
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
